import { render, staticRenderFns } from "./DocumentManagerReport.vue?vue&type=template&id=c05ec2fc&scoped=true&"
import script from "./DocumentManagerReport.vue?vue&type=script&lang=js&"
export * from "./DocumentManagerReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05ec2fc",
  null
  
)

export default component.exports